import { getEnvVarAsBoolean, getEnvVarAsInteger } from './util/environment.helper'
import packageInfo from '../package.json'
import { ENV_PRODUCTION } from './constants'

export const firebaseConfig = {
	apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
	appId: process.env.REACT_APP_FIREBASE_APP_ID,
	authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
	databaseURL: process.env.REACT_APP_FIREBASE_DATABASE_URL,
	messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
	projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
	storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
	storageApi: process.env.REACT_APP_FIREBASE_STORAGE_API,
	measurmentId: process.env.REACT_APP_FIREBASE_MEASURMENT_ID
}

export const mixpanelConfig = {
	token: process.env.REACT_APP_MIXPANEL_TOKEN
}

export const twilioConfig = {
	accountSid: process.env.REACT_APP_TWILIO_ACCOUNT_SID,
	authToken: process.env.TWILIO_AUTH_TOKEN,
	phoneNumbers: {
		US: process.env.REACT_APP_TWILIO_US_PHONE_NUMBER,
		CA: process.env.REACT_APP_TWILIO_CA_PHONE_NUMBER
	}
}

export const SCRATCHPAY_CASH_BACKEND_CONFIG = {
	baseURL: process.env.REACT_APP_CHECKOUT_WEB_BASE_URL
}

export const CHECKOUT_PAYMENT_SERVICE_CONFIG = {
	baseURL: process.env.REACT_APP_CHECKOUT_PAYMENT_SERVICE_BASE_URL
}

export const CHECKOUT_COMMS_SERVICE_CONFIG = {
	baseURL: process.env.REACT_APP_CHECKOUT_COMMS_SERVICE_BASE_URL
}

export const CONTEXT_SERVICE_CONFIG = {
	baseURL: process.env.REACT_APP_CONTEXT_SERVICE_BASE_URL
}

export const GOOGLE_MAPS_CONFIG = {
	apiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY
}

export const CALENDLY_LINKS = {
	payments: process.env.REACT_APP_CALENDLY_LINK_PAYMENTS,
	lending: process.env.REACT_APP_CALENDLY_LINK_LENDING
}

export const ENV = process.env.REACT_APP_DEPLOYMENT_ENV

export const UNIFIED_CONFIG = {
	baseURL: process.env.REACT_APP_UNIFIED_DASH_BASE_URL || 'dashboard.scratchpay.com'
}

export const SENTRY_CONFIG = {
	dsn: process.env.REACT_APP_SENTRY_DSN
}

export const FARO_CONFIG = {
	collectorUrl: process.env.REACT_APP_GRAFANA_FARO_COLLECTOR_URL,
	appName: process.env.REACT_APP_GRAFANA_FARO_APP_NAME,
	samplingRate: process.env.REACT_APP_GRAFANA_FARO_SAMPLING_RATE,
	bundleId: process.env.REACT_APP_GRAFANA_FARO_BUNDLE_ID
}

export const AG_GRID_LICENSE = process.env.REACT_APP_AG_GRID_LICENSE

export const MUI_LICENSE = process.env.REACT_APP_MUI_LICENSE ?? ''

export const CURRENT_VERSION = packageInfo.version

export const FRILL_WIDGET_ID = process.env.REACT_APP_FRILL_WIDGET_ID

export const PAYMENT_BASE_URL = process.env.REACT_APP_PAYMENT_BASE_URL

export const PERSONA_CONFIG = {
	environment: ENV === ENV_PRODUCTION ? 'production' : 'sandbox'
}

export const PLAID_CONFIG = {
	isEnabled: getEnvVarAsBoolean(process.env.REACT_APP_PLAID_ENABLED)
}

export const FLAGS_CONFIG = {
	daysAfterFinalizationToBlockUpdates:
		getEnvVarAsInteger(
			process.env.REACT_APP_FLAGS_DAYS_AFTER_FINALIZATION_TO_BLOCK_UPDATES || ''
		) || 30
}

export const STRIPE = {
	publishableKey: process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY ?? ''
}

export const MAVEN_AGI_CHAT_CONFIG = {
	organizationId: process.env.REACT_APP_MAVEN_AGI_ORGANIZATION_ID ?? '',
	agentId: process.env.REACT_APP_MAVEN_AGI_AGENT_ID ?? ''
}

export const MPH_CONFIG = {
	firebaseTenantId: process.env.REACT_APP_MPH_FIREBASE_TENANT_ID ?? '',
	microsoftTenantId: process.env.REACT_APP_MPH_MICROSOFT_TENANT_ID ?? ''
}

export const PIMS_DATA_SERVICE_CONFIG = {
	baseURL: process.env.REACT_APP_PIMS_DATA_SERVICE_BASE_URL ?? ''
}

export const SCRATCH_BACKEND_BASE_URLS = [
	SCRATCHPAY_CASH_BACKEND_CONFIG.baseURL,
	CHECKOUT_PAYMENT_SERVICE_CONFIG.baseURL,
	CHECKOUT_COMMS_SERVICE_CONFIG.baseURL,
	CONTEXT_SERVICE_CONFIG.baseURL,
	PIMS_DATA_SERVICE_CONFIG.baseURL
].filter((baseURL): baseURL is string => Boolean(baseURL))

export const BANNER_1099_INFO_PARAMS = {
	dueDate: process.env.REACT_APP_BANNER_1099_INFO_DUE_DATE ?? '',
	url: process.env.REACT_APP_BANNER_1099_INFO_URL ?? ''
}

/**
 * Compliance-approved Scratch Capital one-pager PDFs (HubSpot-hosted), shown
 * verbatim in `PdfViewerModal` from the sidebar guide banner and the Capital
 * promo page. Kept in env vars so marketing can swap the assets without a code
 * change. Empty when unconfigured — consumers hide their guide entry points
 * rather than opening a blank viewer.
 */
export const CAPITAL_GUIDES_CONFIG = {
	capitalGapPdfUrl: process.env.REACT_APP_CAPITAL_GUIDE_GAP_PDF_URL ?? '',
	howWillYouUseCapitalPdfUrl: process.env.REACT_APP_CAPITAL_GUIDE_USE_PDF_URL ?? ''
}
